import type { Recipe } from '../../types'
import { image, ingredient, scaled, section } from '../helpers'

export const crepes: Recipe = {
  slug: 'crepes',
  title: 'Crêpes',
  category: 'sucré',
  description: 'De grandes crêpes souples, avec des quantités ajustables selon le nombre d’œufs.',
  image: image('crepes'),
  tags: ['goûter', 'KitchenAid', 'ajustable'],
  meta: [
    { label: 'Préparation', value: '15 à 20 min + 1 à 2 h de repos' },
    { label: 'Cuisson', value: '1 à 2 min par crêpe' },
  ],
  scaler: {
    kind: 'linear',
    label: 'Nombre d’œufs',
    min: 1,
    max: 12,
    step: 1,
    base: 6,
    resultLabel: (value) => `environ ${Math.round(value * 2.5)} crêpes`,
  },
  sections: [
    section('Ingrédients', [
      scaled('farine', 'farine T45', 500, 'g', { display: '500 g de farine T45', shoppingKey: 'farine' }),
      scaled('œufs', 'œufs', 6, 'œuf', { pluralUnit: 'œufs', shoppingKey: 'œuf' }),
      scaled('lait', 'lait entier', 1000, 'mL', { display: '1 L de lait entier', shoppingKey: 'lait' }),
      scaled('sucre', 'sucre vanillé', 60, 'g', {
        display: '60 g de sucre vanillé',
        shoppingKey: 'sucre vanillé',
      }),
      scaled('beurre', 'beurre fondu', 50, 'g', { display: '50 g de beurre fondu', shoppingKey: 'beurre' }),
      scaled('fleur', 'eau de fleur d’oranger', 3, 'c. à soupe', {
        display: '3 c. à soupe d’eau de fleur d’oranger',
      }),
      ingredient('sel', 'sel', '1 pincée de sel'),
    ]),
  ],
  steps: [
    'Préparer le mélange sec : mettre la farine, le sucre vanillé et la pincée de sel dans le bol. Monter la feuille sur le KitchenAid et mélanger à vitesse 2 pendant 30 secondes pour homogénéiser.',
    'Incorporer le lait en trois fois : verser progressivement en mélangeant à vitesse 2–3 (20 à 30 secondes par ajout) jusqu’à obtenir une pâte lisse et sans grumeaux.',
    'Incorporer le beurre fondu et la fleur d’oranger à vitesse 2 pendant 30 secondes, puis ajouter les œufs un à un jusqu’à obtention d’une pâte brillante et souple, idéale pour de grandes crêpes.',
    'Couvrir et laisser reposer au moins une heure avant cuisson.',
  ],
  note: 'Bien faire préchauffer l’appareil une dizaine de minutes et laisser réchauffer 2 minutes entre chaque crêpe.',
}
